import { KeycloakProvider } from '@studio-toolkit/keycloak';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

// Components
import { App } from 'routes';

// Contexts
import { QuantumContextProvider } from 'contexts';

// Utils

// Styles
import { Login } from 'components';
import '@kite/react-kite/dist/react-kite.css';
import './main.scss';

// React Setup
const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Failed to find the root element');
}

const root = createRoot(rootElement);

// React Query Setup
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

root.render(
  // <React.StrictMode>
  <KeycloakProvider>
    <QuantumContextProvider>
      <QueryClientProvider client={queryClient}>
        <Login>
          <App />
        </Login>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </QuantumContextProvider>
  </KeycloakProvider>

  // </React.StrictMode>
);
